import 'element-ui/lib/theme-chalk/index.css' // element-ui css样式

if( process.env.VUE_APP_APP_HOST === 'gpt4') {
    require('./root_gpt4.less')
    require('./login_gpt4.less')
} else {
    require('./root.less')
    require('./login.less')
}

import './common.less'
import './layout.less'
import './apis.less'
import './chat.less'
import './home.less'
import './my.less'
import './mychat.less'